import { createContext } from 'react';
import type { ScenariosContextType } from '../hooks/useScenariosContext';

export const ScenariosContext = createContext<ScenariosContextType | undefined>(undefined);